module.exports = "/_next/static/images/DataScienceModeling-b25ed3c403eae932c1de263dcd72694d.webp";